import { styled } from "@mui/material";

const PageLayout = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
}));

export default PageLayout;
